import { ActionType } from 'typesafe-actions';
import * as notificationsAction from './notifications';

export const notificationActions = { ...notificationsAction };

export type NotificationActions = ActionType<typeof notificationsAction>;
